import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { ShowVerticalScrollbar } from '../../../global/commonStyle';

const ModalBlock = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const SecModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;
const Label = styled.label`
  ${Typography.body_md_medium}
  margin: var(--space-0);
  color: var(--text-secondary);
`;

const Buttons = styled.div`
  display: flex;
  align-items: flex-end;
  gap: var(--space-12);
  justify-content: flex-end;
  margin-top: var(--space-8);
`;

const DropData = styled.div`
  max-height: 94px;
  margin-right: var(--space-4);
  ${ShowVerticalScrollbar}
  ${mobile_xl(css`
    height: 170px;
  `)}
`;

const Icon = styled.div`
  width: 100%;
  height: 8px;
  border-radius: var(--border-radius-full);
  max-width: 8px;
  ${(props: { iconColor: string }) =>
    props.iconColor &&
    css`
      background-color: ${props.iconColor};
    `}
`;

export { Buttons, DropData, Form, Icon, Label, ModalBlock, SecModalContent };
